// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-checkbox .custom-control-label .custom-label[data-v-25206bbf] {\n  position: relative;\n  top: 0.10rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
